import { Injectable } from '@angular/core';
import {BaseService} from '../../../services/base.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from '../../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SliderService extends BaseService {

  constructor(private httpClient: HttpClient , private authService: AuthService) {
    super();

  }

  getSliderByViewstore(view_store): Observable<any> {
    return this.httpClient.get<any>(this.baseAPI2 + `/components/slidermanager/sliders/public/bystoreview/${view_store}` , this.authService.getHttpOptions());
  }


}
